<div class="flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
  <div *ngIf="canManageGroups" class="bulk-bar" [class.bulk-bar--visible]="selectedGroups.length > 0">
    <span class="bulk-bar__count">Zaznaczono: {{ selectedGroups.length }}</span>
    <p-button
      *ngIf="!archived"
      icon="pi pi-inbox"
      label="Archiwizuj"
      [outlined]="true"
      size="small"
      [disabled]="bulkProcessing"
      (onClick)="setArchivedSelected(true)"
      data-clarity-unmask="true"
    ></p-button>
    <p-button
      *ngIf="archived"
      icon="pi pi-replay"
      label="Przywróć"
      [outlined]="true"
      size="small"
      [disabled]="bulkProcessing"
      (onClick)="setArchivedSelected(false)"
      data-clarity-unmask="true"
    ></p-button>
    <p-button
      icon="pi pi-trash"
      label="Usuń"
      [outlined]="true"
      severity="danger"
      size="small"
      [disabled]="bulkProcessing"
      (onClick)="deleteSelected()"
      data-clarity-unmask="true"
    ></p-button>
  </div>
  <div class="search-box ml-auto">
    <i class="pi pi-search"></i>
    <input type="text" pInputText placeholder="wyszukaj" (input)="onSearch($event)" />
  </div>
</div>

<p-table
  [value]="groups"
  dataKey="guid"
  [lazy]="true"
  (onLazyLoad)="loadGroups($event)"
  [paginator]="true"
  [rows]="pageSize"
  [(first)]="first"
  [totalRecords]="totalRecords"
  [loading]="loading"
  [(selection)]="selectedGroups"
  [expandedRowKeys]="expandedRowKeys"
  (onRowExpand)="onRowExpand($event)"
  [rowHover]="true"
  sortField="created"
  [sortOrder]="-1"
  styleClass="lecture-groups-table"
>
  <ng-template pTemplate="header">
    <tr>
      <th *ngIf="canManageGroups" class="col-checkbox"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
      <th class="col-toggle"></th>
      <th pSortableColumn="name">Nazwa grupy <p-sortIcon field="name"></p-sortIcon></th>
      <th pSortableColumn="created">Data utworzenia <p-sortIcon field="created"></p-sortIcon></th>
      <th pSortableColumn="examName">Kategoria <p-sortIcon field="examName"></p-sortIcon></th>
      <th>Prowadzący</th>
      <th class="col-progress">Wykłady</th>
      <th class="col-count">Ilość kursantów</th>
      <th *ngIf="archived">Status</th>
      <th *ngIf="canManageGroups" class="col-actions">Akcje</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-group let-expanded="expanded">
    <tr class="group-row" [class.group-row--expanded]="expanded">
      <td *ngIf="canManageGroups" class="col-checkbox"><p-tableCheckbox [value]="group"></p-tableCheckbox></td>
      <td class="col-toggle">
        <button
          type="button"
          class="transparent-button toggle-button"
          [pRowToggler]="group"
          [attr.aria-label]="expanded ? 'Zwiń kursantów' : 'Pokaż kursantów'"
          [pTooltip]="expanded ? 'Zwiń kursantów' : 'Pokaż kursantów'"
          tooltipPosition="bottom"
          data-clarity-unmask="true"
        >
          <i class="pi" [ngClass]="expanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </button>
      </td>
      <td>
        <div class="flex flex-column md:flex-row align-items-start md:align-items-center justify-content-between gap-2">
          <span class="font-medium group-name">{{ group.name }}</span>
          <span class="row-buttons">
            <button
              type="button"
              class="white-button row-action"
              (click)="archived || !canRunLectures ? showDetails(group) : startLectures(group)"
              data-clarity-unmask="true"
            >
              {{ archived || !canRunLectures ? 'Szczegóły' : lecturesActionLabel(group) }}
              <i class="pi pi-arrow-right"></i>
            </button>
            <button
              type="button"
              class="white-button row-action row-action--icon"
              pTooltip="Lista obecności"
              tooltipPosition="bottom"
              aria-label="Lista obecności"
              (click)="openAttendance(group)"
              data-testid="lecture-group-attendance"
              data-clarity-unmask="true"
            >
              <i class="pi pi-check-square"></i>
            </button>
          </span>
        </div>
      </td>
      <td>{{ group.created | date: 'dd.MM.yyyy' }}</td>
      <td>{{ group.examName }}</td>
      <td class="col-leader">{{ group.leaderName || '—' }}</td>
      <td class="col-progress">
        <div class="lecture-progress-cell" [pTooltip]="progressTooltip(group)" tooltipPosition="top">
          <div class="lecture-progress">
            <div class="lecture-progress__fill" [style.width.%]="group.lecturesProgressPercent"></div>
          </div>
          <div class="lecture-progress__counts">
            <span>Rozdziały {{ group.lecturesCompletedChapters }}/{{ group.lecturesTotalChapters }}</span>
            <span>Slajdy {{ group.lecturesViewedSlides }}/{{ group.lecturesTotalSlides }}</span>
            <span>{{ group.lecturesProgressPercent }}%</span>
          </div>
        </div>
      </td>
      <td class="col-count text-center">{{ group.studentsCount }}</td>
      <td *ngIf="archived"><span class="status-tag">zarchiwizowano</span></td>
      <td *ngIf="canManageGroups" class="col-actions">
        <div class="row-actions">
          <button type="button" class="transparent-button" pTooltip="Edytuj" tooltipPosition="bottom" (click)="editGroup(group)" data-clarity-unmask="true">
            <i class="pi pi-pencil"></i>
          </button>
          <button type="button" class="transparent-button" pTooltip="Usuń" tooltipPosition="bottom" (click)="deleteGroup(group)" data-clarity-unmask="true">
            <i class="pi pi-trash"></i>
          </button>
          <button
            *ngIf="!archived"
            type="button"
            class="transparent-button"
            pTooltip="Dodaj kursantów"
            tooltipPosition="bottom"
            (click)="addStudents(group)"
            data-clarity-unmask="true"
          >
            <i class="pi pi-plus"></i>
          </button>
          <button
            *ngIf="!archived"
            type="button"
            class="transparent-button"
            pTooltip="Archiwizuj"
            tooltipPosition="bottom"
            (click)="setArchived(group, true)"
            data-clarity-unmask="true"
          >
            <i class="pi pi-inbox"></i>
          </button>
          <button
            *ngIf="archived"
            type="button"
            class="transparent-button"
            pTooltip="Przywróć"
            tooltipPosition="bottom"
            (click)="setArchived(group, false)"
            data-clarity-unmask="true"
          >
            <i class="pi pi-replay"></i>
          </button>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-group>
    <tr class="members-row">
      <td [attr.colspan]="(archived ? 10 : 9) - (canManageGroups ? 0 : 2)">
        <div class="members">
          <p *ngIf="membersLoading[group.guid]" class="members__state">Pobieranie kursantów…</p>
          <ng-container *ngIf="!membersLoading[group.guid]">
            <table class="members-table" *ngIf="membersByGroup[group.guid]?.length; else noMembers">
              <thead>
                <tr>
                  <th>Kursant</th>
                  <th>Adres email</th>
                  <th>Numer telefonu</th>
                  <th>Dodano do grupy</th>
                  <th>Status pakietu</th>
                  <th class="col-actions"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let member of membersByGroup[group.guid]" class="member-row">
                  <td>
                    <div class="flex flex-column md:flex-row align-items-start md:align-items-center justify-content-between gap-2">
                      <span>{{ member.displayName }}</span>
                      <button type="button" class="white-button row-action" (click)="showMemberDetails(group, member)" data-clarity-unmask="true">
                        Szczegóły <i class="pi pi-arrow-right"></i>
                      </button>
                    </div>
                  </td>
                  <td>{{ member.email }}</td>
                  <td>{{ member.phone || '—' }}</td>
                  <td>{{ member.added | date: 'dd.MM.yyyy' }}</td>
                  <td>
                    <ng-container *ngIf="member.validTo; else notActivated">
                      <span [style.color]="getStatus(member.validTo).color">{{ getStatus(member.validTo).status }}</span>
                    </ng-container>
                    <ng-template #notActivated><span class="text-gray-500">Użytkownik nie aktywował konta</span></ng-template>
                  </td>
                  <td class="col-actions">
                    <div class="row-actions">
                      <button
                        *ngIf="canManageGroups"
                        type="button"
                        class="transparent-button"
                        pTooltip="Usuń z grupy"
                        tooltipPosition="bottom"
                        (click)="removeMember(group, member)"
                        data-clarity-unmask="true"
                      >
                        <i class="pi pi-user-minus"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <ng-template #noMembers>
              <p class="members__state">
                Brak kursantów w tej grupie.
                <button *ngIf="!archived" type="button" class="link-button" (click)="addStudents(group)" data-clarity-unmask="true">Dodaj kursantów</button>
              </p>
            </ng-template>
          </ng-container>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="(archived ? 10 : 9) - (canManageGroups ? 0 : 2)" class="text-center text-gray-500 py-4">
        {{
          archived
            ? 'Brak zarchiwizowanych grup.'
            : canManageGroups
              ? 'Brak grup. Dodaj pierwszą grupę wykładową.'
              : 'Nie prowadzisz jeszcze żadnej grupy - prowadzącego wybiera szef lub biuro w formularzu grupy.'
        }}
      </td>
    </tr>
  </ng-template>
</p-table>

<p-confirmDialog key="lectureGroupConfirm" [style]="{ width: '480px' }"></p-confirmDialog>
